import React from 'react';
import { connect } from 'react-redux'
import IntlMessages from 'util/IntlMessages';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { NotificationManager } from 'react-notifications';
import { DropdownItem } from 'reactstrap';
import { 
  userSignOut, 
  hideMessage 
} from 'actions/Auth';

class UserInfo extends React.Component {

  componentDidMount() {
    setTimeout(() => {
      this.props.hideMessage();
    }, 1500);
  }

  componentDidUpdate() {
    const { showMessage } = this.props;
    let { alertMessage } = this.props;

    if (showMessage && !this.props.intl.messages[alertMessage]) {
      alertMessage = 'appModule.serverError';
    }

    if (showMessage) {
      NotificationManager.error(<IntlMessages id={alertMessage} />) 
    }
  }


  render() {
    const { authUser } = this.props;

    let status
    if (authUser.permission === 'owner') {
      status = <IntlMessages id="popup.owner" />
    } else if (authUser.permission === 'admin') {
      status = <IntlMessages id="popup.administrator" />
    } else {
      status = <IntlMessages id="popup.user" />
    }

    return (
      <div>
        <div className="user-profile">
          <div className="user-avatar border-0 size-40">
          {authUser.userImage ? 
            <img className="img-fluid" src={authUser.userImage} alt="User"/> :
            <img className="img-fluid" src="http://via.placeholder.com/150x150" alt="User"/>
          }
          </div>
          <div className="user-detail ml-2 p-0">
            <h4 className="user-name mb-0">{authUser.name}</h4>
            <small>{status}</small>
          </div>
        </div>
        <DropdownItem className="dropdown-item text-muted" tag="a" href="#/app/profile">
          <i className="zmdi zmdi-face zmdi-hc-fw mr-1" />
          <IntlMessages id="popup.profile" />
        </DropdownItem>
        {authUser.permission !== 'user' ?
          <DropdownItem className="dropdown-item text-muted" tag="a" href="#/app/company-settings">
            <i className="zmdi zmdi-settings zmdi-hc-fw mr-1" />
            <IntlMessages id="popup.settings" />
          </DropdownItem>
          : ''
        }
        <a className="dropdown-item text-muted" href="javascript:void(0)" onClick={() => {
          this.props.userSignOut()
        }}>
          <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-1"/>
          <IntlMessages id="popup.logout"/>
        </a>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const {
    authUser,
    alertMessage,
    showMessage
  } = auth;
  return {
    authUser,
    alertMessage,
    showMessage
  }
};

let injectedIntl = injectIntl(withRouter(UserInfo));

export default connect(mapStateToProps, {
  userSignOut,
  hideMessage
})(injectedIntl);



// WEBPACK FOOTER //
// ./components/UserInfo/index.js